'use strict';

var angular = require('angular');
var StepMarketShareDirective = function StepMarketShareDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/step-market-share.html'),
    controller: 'StepMarketShareController',
    link: function link(scope) {
      scope.$on('scheduleChange:stepEntered', scope.stepEntered);
      scope.focusErrorMsg = function () {
        angular.element('.assign-mkt-shares-container .content').scrollTop(0);
      };
    }
  };
};
StepMarketShareDirective.$inject = [];
module.exports = StepMarketShareDirective;